import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { AddressFields } from "../AddressFields";
import type { BillingInfoFormValues } from "../BillingInfoFormValues";
import { localeRoot } from "../constants";
import { useBillingInfoContext } from "../useBillingInfoContext";

export const BillingInfoModalFormContent = () => {
  const { formState } = useFormContext<BillingInfoFormValues>();
  const { asPrerequisite: isAsPrerequisite } = useBillingInfoContext();

  const buttonLabel = t([
    localeRoot,
    `submit${isAsPrerequisite ? "_as_prerequisite" : ""}`,
  ]);

  return (
    <>
      <Modal.Body className="pt-3">
        <AddressFields />
      </Modal.Body>
      <Modal.Footer>
        <Button
          full
          large
          variant="primary"
          type="submit"
          disabled={formState.isSubmitting}
        >
          {buttonLabel}
        </Button>
      </Modal.Footer>
    </>
  );
};
